import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  useColorModeValue,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Circle,
  Icon,
  MenuItem,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { PiExportBold, PiGraph } from "react-icons/pi";
import { FaEllipsisV, FaPlus } from "react-icons/fa";
import { CiExport, CiViewTable } from "react-icons/ci";
import { TbFileExport } from "react-icons/tb";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import SalesInvoiceForm from "components/allForm/SalesInvoiceForm/salesInvoiceForm";
import { useLocation } from "react-router-dom";
import { fetchAsyncGetAllSalesInvoice } from "redux/salesInvoice";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { MdModeEdit } from "react-icons/md";
import { AiFillDelete, AiFillEye } from "react-icons/ai";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import prJson from "components/jsonData/purchase.json"
import inJson from "components/jsonData/salesInvoice.json"
import { invoiceDataColumns, invoicePendingDataColumns, invoiceRejectedDataColumns } from "../embrillTable/variables/invoiceColData";
import SalesInvoiceColumnTable from "../embrillTable/SalesInvoiceColumnTable";
import { fetchAsyncDeleteInvoiceOrder } from "redux/salesInvoice";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncHardDeleteInvoiceOrder } from "redux/salesInvoice";
import SalesInvoiceInfoModel from "components/models/SalesInvoiceInfoModal";
import ExportDataModel from "components/exportData/ExportDataModel";
import { getSeletedSalesModuleIcon } from "components/allForm/OrgnizationProfile/expenseModule/moduleIcon";
import ExpenseReports from "../expenseGraph";
import { BiWallet } from "react-icons/bi";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import CurrencySelectField from "components/allForm/SalesItem/currencySelected";
import { allCurrency } from "components/allForm/SalesItem/currencyJson";
import SpentAmountPopover from "components/models/spentAmountPopover";
import useSearch from "hooks/useSearch";
import SalesInvoicePdf from "components/allForm/SalesInvoiceForm/ExportSalesOrder/salesInvoicePdf";

const SalesInvoiceModule = () => {
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const currUser = useSelector((state) => state.auth.currUser);
  const [addSalesModal, setAddSalesModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn, setActiveBtn] = useState("");
  const [moduleInfo, setModuleInfo] = useState({});
  const [activeDataList, setActiveDataList] = useState("approved");
  const [openMenu, setOpenMenu] = useState(false)
  const [activeGraph, setActiveGraph] = useState(false);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [invoiceListData, setInvoiceListData] = useState([]);
  const [isProforma,setIsProforma] = useState(false);
  const [isInv,setIsInv] = useState(false)
  const [openExportMenu,setOpenExportMenu] = useState(false)

  const [selectedItem, setSelectedItem] = useState({});
  const [openInvoiceInfoModal, setOpenInvoiceInfoModal] = useState(false);
  const [invoiceEditModal, setInvoiceEditModal] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const { addToast } = useToasts();
  const {searchText} = useSelector((state) => state.searchValue);
  const location = useLocation();
  const pathSegments = location.pathname.split('/'); 
  const id = pathSegments[pathSegments.length - 1]; 
  const { startDate, endDate } = useSelector((state) => state.dateRange); 
  const salesModule = useSelector((state) => state.salesModule);
  const invoiceList = useSelector(
    (state) => state.invoiceData?.salesInvoices
  );
  const { performSearch } = useSearch();

  const invoiceData = useSelector(
    (state) => state.invoiceData
  );
    const currency = useSelector((state) => state.currency);
    const {currencyCode} = currency;

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === moduleInfo?.name);
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [moduleInfo, currUser]);

  const handleOpenSalesModal = () => {
    setAddSalesModal(true);
    setIsInv(true)

  };
  
  const handleOpenProformaModal = () => {
    setAddSalesModal(true);
    setIsProforma(true)
    setIsInv(false)
  };
  const handleCloseSalesModal = (active) => {
    setAddSalesModal(false);
    setOpenEditModal(false);
    setInvoiceEditModal(null)
    handlerRefreshData();
    setIsProforma(false)
    setIsInv(false)


    if(active){
      setActiveDataList(active)
    }
  };

  useEffect(()=>{
    if(moduleInfo && moduleInfo?._id){
      const data = {
        moduleId:moduleInfo?._id,
        moduleType:moduleInfo?.name
      }
      setLoading(true); 
      dispatch(fetchAsyncGetAllSalesInvoice(data)).then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        setLoading(false); 
      });
    }
  },[moduleInfo])

  const handleGraph = () => {
    setActiveGraph(true);
  };
  const handleTable = () => {
    setActiveGraph(false);
  };


  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn);
  };
  useEffect(()=>{
    if(salesModule && salesModule?.length){
      const module = salesModule.find((item)=> item?._id === id)
      setModuleInfo(module)
    }
  },[id])

  const handlerRefreshData = useCallback(() => {
    performSearch(searchText, startDate, endDate);
  }, [searchText,startDate, endDate]);

  const handleRowClick = (e, _id) => {
    e.preventDefault();
    const data = invoiceList.find((item) => item?._id === _id);
    if(data && data?.isPfi){
      setIsProforma(true)
    }
    if(data && data?.isInv){
      setIsInv(data?.isInv)
    }
    setAddSalesModal(true);
    setOpenEditModal(true);
    setInvoiceEditModal(data);
  };

  const handleTotalAmountByCurrency = (code)=>{
    performSearch(searchText, startDate, endDate,"",code);
  }

  const [exportData,setExportData] = useState({});

  const handleExportMenu = (item)=>{
    setExportData(item);
  }
  
  const getAllInvoiceData = (listData) => {

    if (listData && listData.length > 0) {
      const tableData = listData.map((data, index) => {
        let isGst = data?.gstRc?.length;
        let isTds = data?.tdsApl?.tdsRc?.length;
        const array = data?.pmtRc || [];
        const refundAmount = data?.rfdInfo?.list || [];
        const recivedAmounts = array.map(item => parseFloat(item?.amt || 0)); 

        const totalSpent = array.reduce((acc, item) => acc + (parseFloat(item?.amt) || 0), 0);
        const totalRefund = refundAmount.reduce(
          (acc, item) => acc + (parseFloat(item?.amt) || 0),
          0
        );

        return {
          _id: data._id,
          no: index + 1,
          inNo: (
            data.isInv ?
            <span style={{ cursor: "pointer", color: "blue" }}>
              {data.inNo && InvoiceNumberFormate(data.inNo)}
            </span>
            :
            <span>-</span>
          ),
          pfiNo: (
            data.isPfi ?
            <span style={{ cursor: "pointer", color: "green" }}>
              {data.pfiNo && InvoiceNumberFormate(data.pfiNo)}
            </span>
            :
            <span>-</span>
          ),
          invoiceDate: dateTimeFormat(data?.isInv ? data.inDt : data.pfiDt),
          majorType: (
            <span style={{ cursor: "pointer" }}>{data?.mjId?.val}</span>
          ),
          minorType: (
            <span style={{ cursor: "pointer" }}>{data?.mnId?.val}</span>
          ),
          receivedAmount: (
            <Box display="flex">
              <span
                style={{ cursor: "pointer", width: "90px" }}
                className={
                  parseFloat(totalSpent) - parseFloat(totalRefund)
                    ? "green"
                    : ""
                }
              >
                {formatAmountIndianRupees(
                  totalSpent
                    ? parseFloat(totalSpent) - parseFloat(totalRefund || 0) 
                    : 0 
                )}
                {" "}
                {currencySymbolByCode(data?.inCr|| "INR")}
              </span>

              <SpentAmountPopover
                spentAmounts={recivedAmounts}
                refundAmount={refundAmount}
                currencySymbol={currencySymbolByCode(data?.inCr|| "INR")}
                title="Received Amounts"
              />
            </Box>
          ),
          clientName: (
            <span style={{ cursor: "pointer" }}>
              {data?.clId?.clName}
            </span>
          ),
         
          sortReqAmt: Number(data.pyInfo?.apAmt) || 0,
          approvalAmount: (
            <span
              style={{ cursor: "pointer" }}
              className={data.pyInfo?.sts !== 1 ? "red" : "green"}
            >
              {formatAmountIndianRupees(data.pyInfo?.apAmt || 0)} {currencySymbolByCode(data?.inCr|| "INR")}
            </span>
          ),
          sortApdAmt: data.pyInfo?.apAmt || 0,
          approvedAmount: (
            <Box display="flex" alignItems="self-start">
              <span style={{ cursor: "pointer", width: "100px" }}>
              {formatAmountIndianRupees(data.pyInfo?.apAmt || 0)} {currencySymbolByCode(data?.inCr || "INR")}
              </span>
              {isGst ? (
                <Circle
                  title="GST Applicable"
                  className="mx-1 my-1 gt-tag"
                  size="3"
                >
                  G
                </Circle>
              ):""}
              {isTds ? (
                <Circle
                  title="Tds Deducted"
                  className="mx-1 my-1 gt-tag"
                  size="3"
                >
                  T
                </Circle>
              ):""}
             
            </Box>
          ),
          invoice: (
            <div className="item-export-menu add-new-btn">
              <Menu>
                <MenuButton
                  onClick={()=>handleExportMenu(data)}
                  title="Export"
                  className="new-btn add-new-menu-btn"
                >
                  <Box display="flex">
                    <PiExportBold fontSize={18} />
                  </Box>
                </MenuButton>
                  <MenuList className="menu-list">
                    <MenuItem
                      className={`menu-item`}
                      isDisabled={!data?.isInv}
                      onClick={() => setOpenExportMenu(!openExportMenu)}
                    >
                      Tax Invoice
                    </MenuItem>
                    <MenuItem
                      className={`menu-item`}
                      isDisabled={!data?.isPfi}
                      onClick={() => {
                        setOpenExportMenu(!openExportMenu);
                        setIsProforma(true);
                      }}
                    >
                      Proforma Invoice
                    </MenuItem>
                  </MenuList>
              </Menu>
            </div>
          ),
          status: "Rejected",
          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                title="Edit"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e, data._id);
                }}
              />
              <AiFillEye
                className="me-2"
                title="View"

                color="#000D55"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedItem(data);
                  setOpenInvoiceInfoModal(true);
                }}
              />
              {role === "Admin" ? (
                <>
                  <AiFillDelete
                    style={{ cursor: "pointer" }}
                    title="Delete"
                    size={16}
                    onClick={(e) => {
                      e.preventDefault();
                      const title = inJson.confirm.deleteIn.replace(
                        "{inNumber}",
                        data.inNo ? InvoiceNumberFormate(data.inNo) : ""
                      );
                      ConfirmationDialog({
                        title: title,
                        text: prJson.text.undone,
                        icon: "warning",
                        confirmButtonText: "Delete",
                        cancelButtonText: "Cancel",
                        onConfirm: () => {
                          setLoading(true)
                          const inNo = InvoiceNumberFormate(data.inNo)
                          dispatch(fetchAsyncDeleteInvoiceOrder({moduleId:moduleInfo?._id,id:data._id})).then(() => {
                            handlerRefreshData();
                            const msg = inJson.success.deletedIn.replace("{inno}",inNo)
                            addToast(msg, { appearance: "success" });      
                            setLoading(false)
                          }).catch((err)=>{
                            setLoading(false)
                            addToast(inJson.failed.deletedIn, { appearance: "error" });
                          });;
                        },
                      });
                    }}
                  />
                  <AiFillDelete
                    title="Hard Delete"
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: "3px",
                    }}
                    size={16}
                    onClick={(e) => {
                      e.preventDefault();
                      const inNo = InvoiceNumberFormate(data.inNo)

                      const title = inJson.confirm.deleteIn.replace(
                        "{inNumber}",
                        inNo ? inNo : ""
                      );
                      ConfirmationDialog({
                        title: title,
                        text: prJson.text.undone,
                        icon: "warning",
                        confirmButtonText: "Delete",
                        cancelButtonText: "Cancel",
                        onConfirm: () => {
                          setLoading(true);
                          dispatch(fetchAsyncHardDeleteInvoiceOrder({moduleId:moduleInfo?._id,id:data._id}))
                            .then((res) => {
                              handlerRefreshData();
                              const msg = inJson.success.deletedIn.replace(
                                "{inno}",
                                inNo
                              );
                              addToast(msg, { appearance: "success" });
                              setLoading(false);
                            })
                            .catch((err) => {
                              setLoading(false);
                              addToast(inJson.failed.deletedIn, {
                                appearance: "error",
                              });
                            });
                        },
                      });
                    }}
                  />
                </>
              ) : null}
            </div>
          ),
        };
      });
      setInvoiceListData(tableData);
     
    } else {
      setInvoiceListData([]);
    }
  };

  const handleExpenseListData = () => {
    if (!invoiceList || invoiceList.length === 0) {
      setInvoiceListData([]);
      return;
    }
    const listData = invoiceList.filter((item) => {
      if (activeDataList === "approved") {
        return item.pyInfo.sts === 1;
      }
      if (activeDataList === "pending") {
        return item.pyInfo.sts === 0

      }
      return item.pyInfo.sts === 2

    });
    getAllInvoiceData(listData);
  };

  useEffect(() => {
    handleExpenseListData();
  }, [invoiceList, activeDataList]);


  const closeInvoiceInfoModal = () => {
    setOpenInvoiceInfoModal(false);
    setSelectedItem({});
  };
  
  const handleOpenMenu = () => {
    setOpenMenu(true);
  };
  
  if (loading) {
    return <SpinnerLoader />;
  }
  return (
    <>
      <Box display="flex" className="mx-0" justifyContent="space-between">
        <Box
          display="flex"
          justifyContent="space-between"
          className="tab-btn mx-2"
        >
          {!activeGraph && (
            <>
            <Box className="tab-btn-div">
              <div
                className={`div-btn ${
                  activeDataList === "approved" ? "active-tab-btn" : ""
                }`}
                onClick={() => setActiveDataList("approved")}
              >
                Approved
              </div>
              <div
                className={`div-btn ${
                  activeDataList === "pending" ? "active-tab-btn" : ""
                }`}
                onClick={() => setActiveDataList("pending")}
              >
                Pending
              </div>
              <div
                className={`div-btn ${
                  activeDataList === "rejected" ? "active-tab-btn" : ""
                }`}
                onClick={() => setActiveDataList("rejected")}
              >
                Rejected
              </div>
              
            </Box>
            <div className="mx-1">
            <CurrencySelectField
              options={allCurrency}
              placeHolder=""
              defaultValue={allCurrency.find((item)=>item.code === currencyCode)}
              isSearchable
              onChange={(newValue) => {
                handleTotalAmountByCurrency(newValue?.code || "INR")             
              }}
            />
          </div>
            </>
          )}
         
        </Box>

        <div className="graph_button internal-graph-btn mx-2">
          <button
            title="Data View"
            className={`graph_icon_button ${
              !activeGraph ? "active_graph" : ""
            }`}
            onClick={() => handleTable()}
          >
            <CiViewTable />
          </button>
          {role !== "Accountant" ? (
            <button
              title="Analytics View"
              className={`graph_icon_button ${
                activeGraph ? "active_graph" : ""
              }`}
              onClick={() => handleGraph()}
            >
              <PiGraph />
            </button>
          ) : (
            <button
              title="Analytics View"
              className={`graph_icon_button ${
                activeGraph ? "active_graph" : ""
              }`}
              style={{ opacity: "0.3", cursor: "not-allowed" }}
            >
              <PiGraph />
            </button>
          )}
          
        </div>

        {!activeGraph && (
          <Box display="flex" mt={2} className="add-new-btn ">
            <Menu>
              <MenuButton
                onClick={handleOpenMenu}
                className="new-btn add-new-menu-btn"
              >
                <Box display="flex">
                  <FaPlus size={12} className="new-plus-icon" />{" "}
                  <span>New</span>
                </Box>
              </MenuButton>
              {openMenu && (
                <MenuList className="menu-list">
                  <MenuItem
                    className={`menu-item`}
                    onClick={handleOpenSalesModal}
                  >
                    Invoice
                  </MenuItem>
                  <MenuItem
                    className={`menu-item`}
                    onClick={handleOpenProformaModal}
                  >
                    Proforma Invoice
                  </MenuItem>
                </MenuList>
              )}
            </Menu>

            <Box>
              <Menu>
                <MenuButton p="0px">
                  <Box className="menu-ellipsis-btn">
                    <FaEllipsisV />
                  </Box>
                </MenuButton>
                <MenuList
                  boxShadow={shadow}
                  p="0px"
                  borderRadius="10px"
                  bg={menuBg}
                  border="none"
                >
                  <Flex w="100%" mb="0px" flexDirection="column">
                    <Box
                      ps="20px"
                      pt="10px"
                      pb="8px"
                      className="menu-text"
                      borderBottom="1px solid gray"
                      borderColor={borderColor}
                      onClick={() => toggleMenu("xlsx")}
                      display="flex"
                    >
                      <CiExport size={20} className="mx-1" />{" "}
                      <span>Export XLSX</span>
                    </Box>
                  </Flex>
                  <Flex w="100%" mb="0px" flexDirection="column"></Flex>
                  <Flex w="100%" mb="0px" flexDirection="column">
                    <Box
                      ps="20px"
                      pb="8px"
                      pt="5px"
                      borderBottom="1px solid gray"
                      borderColor={borderColor}
                      display="flex"
                      className="menu-text"
                      onClick={() => toggleMenu("invoice")}
                    >
                      <TbFileExport size={20} className="mx-1" />
                      <span>Export Invoice</span>
                    </Box>
                  </Flex>
                  <Box marginRight={40}>
                    <ExportDataModel
                      filename={`${moduleInfo.name}_`}
                      type="SalesInvoice"
                      role={role}
                      isOpen={isOpen}
                      handleClose={() => {
                        setActiveBtn("");
                        setIsOpen(false);
                      }}
                      activeBtn={activeBtn}
                      moduleId={moduleInfo?._id}
                    />
                  </Box>
                </MenuList>
              </Menu>
            </Box>
          </Box>
        )}
      </Box>

      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        {activeGraph ? (
          <Box className={`graph-card ${activeGraph ? "graph_active" : ""}`}>
            <ExpenseReports
              name={`${moduleInfo?.name} Total Expense`}
              heading={moduleInfo?.name}
              icon={
                moduleInfo?.icnImg &&
                getSeletedSalesModuleIcon(moduleInfo.icnImg) ? (
                  getSeletedSalesModuleIcon(moduleInfo.icnImg)
                ) : (
                  <Icon w="22px" h="22px" as={BiWallet} />
                )
              }
              role={role}
              moduleId={moduleInfo?._id}
              type={moduleInfo?.name}
              moduleType={moduleInfo?.typ}
              expenseType="SalesInvoice"
            />
          </Box>
        ) : (
          <SalesInvoiceColumnTable
            columnsData={
              activeDataList === "rejected"
                ? invoiceRejectedDataColumns
                : activeDataList === "pending"
                ? invoicePendingDataColumns
                : invoiceDataColumns
            }
            tableData={invoiceListData}
            openInfoModal={handleRowClick}
            expenseType={moduleInfo?.name}
            type={moduleInfo?.name}
            activeDataList={activeDataList}
            role={role}
            paymentData={invoiceData}
            chnageDataList={(value) => setActiveDataList(value)}
          />
        )}
      </Box>

      {addSalesModal && (
        <SalesInvoiceForm
          openModal={addSalesModal}
          closeModal={handleCloseSalesModal}
          isEdit={openEditModal}
          editData={invoiceEditModal}
          refreshEditData={handlerRefreshData}
          activeList={activeDataList}
          role={role}
          expenseType={moduleInfo?.name}
          prefix={moduleInfo?.prfx}
          moduleInfo={moduleInfo}
          isProforma={isProforma}
          isInvoice={isInv}
          pfPrefix={moduleInfo?.pfPrfx}

        />
      )}
      {openInvoiceInfoModal && (
        <SalesInvoiceInfoModel
          openInfoModal={openInvoiceInfoModal}
          closeInfoModal={closeInvoiceInfoModal}
          selectedItem={selectedItem}
          role={role}
          expenseType={moduleInfo?.name}
          moduleInfo={moduleInfo}
        />
      )}
      {openExportMenu && (
          <SalesInvoicePdf
            isOpen={openExportMenu}
            onClose={() => {
              setOpenExportMenu(!openExportMenu);
              setIsProforma(false);
              setExportData({})
            }}
            isProforma={isProforma}
            expenseData={exportData}
            itemList={exportData?.pyInfo?.itms}
            moduleId={moduleInfo?._id}
          />
        )}
    </>
  );
};

export default SalesInvoiceModule;
